import FillBlanks from "../../components/ClassOne/EnvironmentScience/OurHelpers/FillBlanks";
import MultipleChoice from "../../components/ClassOne/EnvironmentScience/OurHelpers/MultipleChoice";
import TrueFalse from "../../components/ClassOne/EnvironmentScience/OurHelpers/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/environmental-science/our-helpers/fill-blanks", title: "Fill in the Blanks", component: FillBlanks },
    { url: "/class-one/environmental-science/our-helpers/true-false", title: "True or False", component: TrueFalse },
    { url: "/class-one/environmental-science/our-helpers/multiple-choice-question", title: "Multiple Choice Questions", component: MultipleChoice },
];

export default topics;